module.exports = __webpack_public_path__ + "img/cup-spray-gun-5360677.a7d1724e.png";